import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('identifierService', identifierService);

    function identifierService() {
        var IDENTIFIERS = {
            DVGW: 'DVGW',
            EIC: 'EIC',
            PRIMA: 'Prima-Code'
        };

        /**
         * better readable names for messages
         *
         * @type {{DVGW: string, EIC: string, PRIMA: string}}
         */
        var MESSAGE_IDENTIFIER = {
            DVGW: 'DVGW-Code'
        };

        return {
            getIdentifierFromIdentifierList: getIdentifierFromIdentifierList,
            convertToReadableIdentifier: convertToReadableIdentifier,
            IDENTIFIERS: IDENTIFIERS
        };

        function getIdentifierFromIdentifierList(identifierList, identifier) {
            if (!identifierList) return null;
            for (var i = 0; i < identifierList.length; i++) {
                if (identifierList[i].type === identifier) {
                    return identifierList[i].id;
                }
            }
            return null;
        }

        function convertToReadableIdentifier(identifier) {
            if (!!MESSAGE_IDENTIFIER[identifier]) {
                return MESSAGE_IDENTIFIER[identifier];
            }
            return identifier;
        }
    }
})();
